import {MainRequest} from 'Services/common';
import Config from '../../../config';

export interface GetPlatform extends PaginationAntD {
    userName: string;
}

const _customerId = Config.IS_BIGDATA_ADMIN;

export interface PlatformList {
    password: string; //    密码
    loginHandlerWechatNumber: string; //    登录提醒的接收人微信号
    customerId: string; //    所属租户id 这里暂时固定为99
    id: string; //    id
    userName: string; //    用户名
    createDate: string; //    创建时间
}

//获取
export function getPlatformPage(params?: GetPlatform) {
    return MainRequest.post<SuccessData<PlatformList[]>>(
        '/wechatSaas/findWechatCustomerAccountList',
        {
            ...params,
            customerId: _customerId,
            pageNo: params?.current,
            pageSize: params?.pageSize,
        },
    )
        .then(res => res.data.data)
        .then(res => {
            return {
                total: res?.length,
                data: res,
            };
        });
}

//编辑
export interface SavePlatform {
    password: string;
    id: string;
    userName: string; //    用户名
    loginHandlerWechatNumber: string; //    登录提醒的接收人微信号
}
export function editPlatform(data: SavePlatform) {
    return MainRequest.post('/wechatSaas/saveWechatCustomerAccount', {
        ...data,
        customerId: _customerId,
    });
}

//删除
export function deletePlatform(id: string) {
    return MainRequest.get(`/wechatSaas/deleteWechatCustomerAccount/${id}`);
}
